import React from 'react';
// Defined in general.js
/* global dcAnalytics isVIPDonor isMobileView readCookie createCookie */
// Replacement for GiveWidgetMixin.js

function useGiveWidget() {
    const [showGiveWidget, setShowGiveWidget] = React.useState(false);

    const toggleGiveWidget = function () {
        const showWidget = !showGiveWidget;
        setShowGiveWidget(showWidget);

        createCookie('showGiveWidget', showWidget.toString());
    };

    React.useEffect(() => {
        const cookieShowGiveWidget = readCookie('showGiveWidget');
        const show = !isMobileView() &&
            (
                cookieShowGiveWidget === 'true' ||
                // default give widget on for top donors only
                (isVIPDonor() && cookieShowGiveWidget === null)
            );
        setShowGiveWidget(show);

        if (typeof dcAnalytics !== 'undefined') {
            dcAnalytics.track('Initial Give Widget Toggle', {
                cookieShowGiveWidget: (cookieShowGiveWidget === null ? 'not set' : cookieShowGiveWidget),
                show: show.toString(),
            });
        }
    }, []);

    return [showGiveWidget, toggleGiveWidget];
}
export default useGiveWidget;
